export default __webpack_public_path__ + "static/media/chaticon-24.72785c00.svg";